import { Box, Money, Support, TextBody, Time, theme } from '@zappyrent/hundop';
import React from 'react';
import Media from 'react-media';

import {
  StyledButtonContainer,
  StyledCtaButton,
  StyledH3,
  StyledIconList,
  StyledLargeSubtitle,
} from '../TextPageLandlord/TextPageLandlord.styles';

const PercheAffittareCasa = (): JSX.Element => {
  return (
    <>
      <StyledH3 sm="24px" md="24px" lg="24px" tag="h3">
        Perché affittare casa con Zappyrent?
      </StyledH3>
      <TextBody>
        Come accennato, Zappyrent è una piattaforma che gestisce affitti a
        medio-lungo termine e funge da intermediario tra domanda (inquilino) e
        offerta (proprietario), sostituendosi di fatto alle agenzie immobiliari.
      </TextBody>
      <StyledLargeSubtitle tag="strong">
        I vantaggi del portale
      </StyledLargeSubtitle>
      <StyledIconList
        content={[
          {
            icon: <Money />,
            body: (
              <>
                <TextBody tag="strong">Risparmio di tempo e denaro</TextBody>
                <TextBody>
                  Innanzitutto, un notevole <strong>risparmio di tempo</strong>{' '}
                  (le visite agli immobili possono essere evitate grazie ai tour
                  virtuali e alle gallerie di immagini){' '}
                  <strong>e di denaro</strong> (non sono richieste le elevate
                  commissioni delle agenzie immobiliari). Una volta caricato
                  l’annuncio, è Zappyrent che&nbsp;lavora.
                </TextBody>
              </>
            ),
          },
          {
            icon: <Time />,
            body: (
              <>
                <TextBody tag="strong">Affitto puntuale e garantito</TextBody>
                <TextBody>
                  Chi vi si rivolge può inoltre usufruire di Protezione
                  Zappyrent, la nostra formula di protezione sull’affitto che{' '}
                  <strong>garantisce pagamenti mensili sicuri</strong>,{' '}
                  indipendentemente dalla puntualità dell’inquilino.
                </TextBody>
              </>
            ),
          },
          {
            icon: <Support />,
            body: (
              <>
                <TextBody tag="strong">Supporto costante e continuo</TextBody>
                <TextBody>
                  Affittare con questa piattaforma offre l’ulteriore vantaggio
                  della più assoluta{' '}
                  <strong>disponibilità di informazioni e supporto</strong>, in
                  quanto sia inquilini che proprietari possono accedere al sito
                  per visionare le notizie di loro interesse e chiedere
                  l’assistenza necessaria al team di&nbsp;Zappyrent.
                </TextBody>
              </>
            ),
          },
        ]}
      />
      <Media
        queries={{
          mobile: `(max-width: calc(${theme.breakpoints.l} - 1px))`,
          desktop: `(min-width: ${theme.breakpoints.l})`,
        }}
        defaultMatches={{ desktop: true }}
      >
        {matches => (
          <>
            {matches.desktop && (
              <StyledButtonContainer>
                <Box lg={2}>
                  <StyledCtaButton
                    href={`${process.env.GATSBY_SITE_URL}/it/pubblica-annuncio-gratis`}
                    tag="a"
                    title="Pubblica un Annuncio"
                  >
                    Pubblica un annuncio
                  </StyledCtaButton>
                </Box>
              </StyledButtonContainer>
            )}
          </>
        )}
      </Media>
    </>
  );
};

export default PercheAffittareCasa;
